<template>
  <form class="w-full mx-auto mt-4 bg-white border border-brand-gray-400 rounded-2xl px-3 py-3 md:px-12 md:py-12"
        @submit.prevent="recaptcha">
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="firstName">
        First Name
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('firstName')}"
      >
        <input
            class="appearance-none block w-full px-3 py-4 border border-brand-gray-300 rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            v-model="form.firstName"
            required
            id="firstName" type="text" placeholder="First Name:">
        <p class="text-orange-600 text-sm font-bold italic text-center" v-if="errors.hasOwnProperty('firstName')">
          {{ errors.firstName[0] }}</p>
      </div>
    </div>
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="lastName">
        Last Name
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('lastName')}"
      >
        <input
            class="appearance-none block w-full px-3 py-4 border border-brand-gray-300 rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            v-model="form.lastName"
            required
            id="lastName" type="text" placeholder="Last Name:">
      </div>
      <p class="text-orange-600 text-sm font-bold italic text-center" v-if="errors.hasOwnProperty('lastName')">
        {{ errors.lastName[0] }}</p>
    </div>
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="emailAddress">
        Email Address
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('emailAddress')}"
      >
        <input
            class="appearance-none block w-full px-3 py-4 border border-brand-gray-300 rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            v-model="form.emailAddress"
            required
            id="emailAddress" type="email" placeholder="Email:">
        <p class="text-orange-600 text-sm font-bold italic text-center" v-if="errors.hasOwnProperty('emailAddress')">
          {{ errors.emailAddress[0] }}</p>
      </div>
    </div>
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="password">
        Password
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('password')}"
      >
        <input
            class="appearance-none block w-full px-3 py-4 border border-brand-gray-300 rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            v-model="form.password"
            required
            id="password" type="password" placeholder="Password:">
        <p class="text-orange-600 text-sm font-bold italic text-center" v-if="errors.hasOwnProperty('password')">
          {{ errors.password[0] }}</p>
      </div>
    </div>
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="phone">
        Mobile Phone Number
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('phone')}"
      >
        <input
            class="appearance-none block w-full px-3 py-4 border border-brand-gray-300 rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            type="tel"
            v-model="form.phone"
            required
            id="phone" placeholder="Mobile Phone:">
        <p class="text-orange-600 text-sm font-bold italic text-center" v-if="errors.hasOwnProperty('phone')">
          {{ errors.phone[0] }}</p>
      </div>
    </div>
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="nursingSchoolState">
        Your Nursing School's State or Province
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('nursingSchoolState')}"
      >
        <div class="relative w-full">
          <select id="nursingSchoolState"
                  class="form-select text-brand-gray-500 appearance-none block w-full px-3 py-4 border rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  v-model="form.nursingSchoolState" @change="loadSchools" required>
            <option value="" class="text-brand-gray-600" disabled>-- Select Your Nursing School's State/Province --</option>
            <option value="non-us-ca" class="text-brand-gray-600">Outside of The US / Canada</option>
            <option disabled>----------------------------</option>
            <option class="text-brand-gray-600" v-for="state in stateProvince" :key="state.abbreviation"
                    :value="state.abbreviation">{{ state.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="nursingSchool">
        Your Nursing School
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('nursingSchoolId')}"
      >
        <div class="relative w-full">
          <select id="nursingSchool"
                  class="form-select text-brand-gray-500 appearance-none block w-full px-3 py-4 border rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  v-model="form.nursingSchoolId" :disabled="schools.length < 1" required>
            <option value="" class="text-brand-gray-600" v-if="schools.length > 0">-- Select Your Nursing School --</option>
            <option value="" class="text-brand-gray-600" v-else disabled>-- Select Your School's State First --</option>
            <option class="text-brand-gray-600" v-for="school in schools" :key="school.schoolId" :value="school.schoolId">
              {{ school.schoolName }}
            </option>
          </select>
        </div>
        <p class="text-orange-600 text-sm font-bold italic text-center" v-if="errors.hasOwnProperty('nursingSchoolId')">
          {{ errors.nursingSchoolId[0] }}</p>
      </div>
    </div>
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="degreeType">
        Your Degree Type
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('nursingSchoolState')}"
      >
        <div class="relative w-full">
          <select id="degreeType"
                  class="form-select text-brand-gray-500 appearance-none block w-full px-3 py-4 border rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  v-model="form.programType" required>
            <option value="" class="text-brand-gray-600" disabled>-- Select Your Degree Type --</option>
            <option value="RN">RN</option>
            <option value="PN">LPN</option>
          </select>
        </div>
      </div>
    </div>
    <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
      <label class="md:col-span-2 block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="gradDate">
        Your Graduation Date
      </label>
      <div class="md:col-span-2 mt-1 md:mt-0 rounded-lg shadow-sm"
           :class="{'border-red-500': errors.hasOwnProperty('graduationDate'),'border-2': errors.hasOwnProperty('graduationDate')}"
      >
        <div class="relative w-full">
          <v-date-picker
              :input-props='{
                                id: "gradDate",
                                class: "appearance-none block w-full px-3 py-4 border border-brand-gray-300 rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                placeholder: "Graduation Date"
                            }'
              is-dark
              color="indigo"
              v-model="graduationInput"></v-date-picker>
        </div>
        <p class="text-orange-600 text-sm font-bold italic text-center" v-if="errors.hasOwnProperty('graduationDate')">
          {{ errors.graduationDate[0] }}</p>
      </div>
    </div>
    <div class="mt-8 mb-4 md:grid md:grid-cols-2 md:gap-6 items-center">
      <div class="md:col-start-2 space-y-6">
        <button class="btn btn-orange rounded-full mb-3 w-full focus:outline-none focus:ring py-4" type="submit">
          Start Your Free Trial
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import {range} from 'lodash/core';
import moment from 'moment';
import axios from 'axios';
import Swal from 'sweetalert2';

import Vue from 'vue'
import {VueReCaptcha} from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {siteKey: '6LfjgD4oAAAAANkZzyTDusefm63rGy-oMOCvGgDq'})

export default {
  name: "FreeTrialForm",

  props: {
    embed: {
      type: Boolean,
      default: false
    },
    stateProvince: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      errors: {},
      form: {
        firstName: '',
        emailAddress: '',
        graduationDate: '',
        lastName: '',
        nursingSchoolId: '',
        nursingSchoolState: '',
        password: '',
        phone: '',
        programType: '',
        userName: '',
        recaptchaToken: null
      },
      graduationInput: '',
      schools: []
    }
  },

  computed: {
    years() {
      return range(moment().year() - 3, moment().year() + 5);
    }
  },

  watch: {
    'form.emailAddress': function (newEmailAddress, oldEmailAddress) {
      this.form.userName = newEmailAddress;
    },
    graduationInput: function (newDate, oldDate) {
      this.form.graduationDate = moment(newDate).format('YYYY-MM-DD');
    }
  },

  methods: {
    async recaptcha() {
      Swal.fire({
        title: 'Please Wait',
        icon: 'info',
        html: 'Submitting<br/><i class="fal fa-spinner fa-spin fa-3x"></i>',
        showCloseButton: false,
        showConfirmButton: false,
      });
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "submit".
      const token = await this.$recaptcha('submit')

      // Do stuff with the received token.
      this.form.recaptchaToken = token;
      await this.save(token);
    },
    async loadSchools() {
      try {
        const {data} = await axios.get(`/ajax/schoolByState/${this.form.nursingSchoolState}`);
        this.schools = data;
      } catch (e) {

      }
    },

    async save() {
      this.errors = {};
      Swal.fire({
        title: 'Please Wait',
        icon: 'info',
        html: 'We are creating your free trial account<br/><i class="fal fa-spinner fa-spin fa-3x"></i>',
        showCloseButton: false,
        showConfirmButton: false,
      });
      try {
        await axios.post('/free-trial', this.form);
        if (this.embed) {
          window.location = '/free-trial/thanks';
        } else {
          window.location = '/my-account';
        }

      } catch (e) {
        Swal.close();
        this.errors = e.response.data.errors;
      }
    }
  }
}
</script>

<style scoped>

</style>